import { useInfiniteQuery } from '@tanstack/react-query'
import { transactionsApi } from '@/api'

export const useGetPostedTransactions = () => {
  return useInfiniteQuery({
    queryKey: ['all_transaction'],
    queryFn: async ({ pageParam }) => transactionsApi.getTransactions('', '', pageParam),
    initialPageParam: '',
    getNextPageParam: lastPage => lastPage?.pageInfo?.endCursor,
    staleTime: 300000,
  })
}
